// Misc State

export default {
  baseUrls: '',
  displayGreeting: true,
  footerIcons: [
    { icon: 'mdi-web', tooltip: 'KeenTech website', link: '//keentech.co' },
    {
      icon: 'mdi-facebook',
      tooltip: 'KeenTech on Facebook',
      link: '//www.facebook.com/KeenTechCompany'
    },
    {
      icon: 'mdi-instagram',
      tooltip: 'KeenTech on Instagram',
      link: '//www.instagram.com/keentech_company'
    },
    {
      icon: 'mdi-linkedin',
      tooltip: 'KeenTech on Linkedin',
      link: '//www.linkedin.com/company/keentech'
    }
  ],
  monthListEn: [
    { text: 'january', value: '01' },
    { text: 'february', value: '02' },
    { text: 'march', value: '03' },
    { text: 'april', value: '04' },
    { text: 'may', value: '05' },
    { text: 'june', value: '06' },
    { text: 'july', value: '07' },
    { text: 'august', value: '08' },
    { text: 'september', value: '09' },
    { text: 'october', value: '10' },
    { text: 'november', value: '11' },
    { text: 'december', value: '12' }
  ]
}
